import MsgDetailList from './MsgDetailList.vue'

MsgDetailList.install = function (Vue) {
  Vue.component(MsgDetailList.name, MsgDetailList)
}

export default MsgDetailList
